export default __webpack_public_path__ + "static/21-f0166e54753d034528b401560065b381.jpg";